"use client";

import { CheckIcon } from "@heroicons/react/16/solid";
import { GenericButton } from "../general/button.component";
import { Spinner } from "@material-tailwind/react";
import { sendOTP } from "@capex/services/apiQueries/user";
import { useTransition } from "react";
import { toast } from "react-toastify";
import { PageFrameComponent } from "../general/page-frame.component";

export const PaymentSuccesfulComponent = ({
	setStage,
	setOtp,
	phoneNumber,
	email,
	firstName,
}: {
	setStage: (stage: number) => void;
	setOtp: (otp: string) => void;
	phoneNumber: string;
	email: string;
	firstName: string;
}) => {
	const [isPending, startTransition] = useTransition();

	const handleGetOTP = async () => {
		startTransition(async () => {
			try {
				const res = await sendOTP({
					phone: phoneNumber,
					email,
					firstName,
				});
				if (res === "An error occurred") {
					toast.error("An error occurred, please try again");
				} else {
					setOtp(res);
					setStage(6);
				}
			} catch (error) {
				toast.error("An unexpected error occurred.");
			}
		});
	};

	return (
    <PageFrameComponent>
      <div className="h-full grid grid-cols-1 place-content-center w-full gap-y-16">
        <div className="flex flex-col items-center justify-center gap-6 py-9 w-full md:w-[400px] bg-pale mx-auto">
          <div className="h-[75px] w-[75px] bg-success rounded-full flex items-center justify-center">
            <CheckIcon className="h-14 w-20 text-white" />
          </div>
          <p className="font-medium text-lg md:text-xl text-text-dark">
            Premium Payment Succesful
          </p>
        </div>
        <div className="text-center">
          <div className="mb-7">
            <p className="font-semibold text-3xl text-secondary">
              Sign In to Continue
            </p>
          </div>
          <div className="flex flex-col gap-y-4 text-lg text-text-dark items-center justify-center mb-7">
            <p>
              An OTP will be sent to your registered phone number and email
              address
            </p>
            <p className="font-medium tracking-wide">
              {`${phoneNumber.slice(0, 2)}******${phoneNumber.slice(
                phoneNumber.length - 3,
                phoneNumber.length
              )}`}{" "}
              |{" "}
              {`${email.slice(0, 2)}******${email.slice(
                email.length - 10,
                email.length
              )}`}
            </p>
          </div>
          <div className="w-full md:w-[450px] mx-auto">
            <GenericButton
              type="submit"
              className="bg-primary !w-full"
              onClick={handleGetOTP}
            >
              {isPending ? (
                <div className="flex justify-center items-center">
                  <Spinner className="h-6 w-6" {...({} as any)} />
                </div>
              ) : (
                "Get OTP"
              )}
            </GenericButton>
          </div>
        </div>
      </div>
    </PageFrameComponent>
  );
};